<template>
  <div id="publishing-special-issue-article">
    <div class="ipub-h1 relative mar-b-20">
      <div style="width:calc(100% - 350px)"
           v-html="detail.title"></div>
      <div class="right-option ipub-p1">
        <ipub-button type="primary"
                     v-if="type==='planned'&&user.codeList&&(user.codeList.includes('WEBSITE.TOPICS.DETAILS.PLANNED_PAPERS.ADD'))"
                     @click="add">
          Add New Planned Paper
        </ipub-button>
        <ipub-button v-if="user.codeList&&user.codeList.includes('WEBSITE.TOPICS.DETAILS.PLANNED_PAPERS.EXPORT')"
                     type="primary"
                     @click="exp">
          Export
        </ipub-button>
      </div>
    </div>
    <site-search-group class="mar-b-20"
                       v-model.trim="keyword"
                       placeholder="Search by manuscript No., DOI, title or authors"
                       @search="getList()"
                       @clear="handleClear" />
    <div class="ipub-list-tab mar-b-30 ipub-p1">
      <a v-if="user.codeList&&user.codeList.includes('WEBSITE.TOPICS.DETAILS.PUBLISHED_PAPERS')"
         @click="changeType('published')"
         :class="['ipub-list-tab--status',type==='published'?'active':'']">Published Papers</a>
      <a v-if="user.codeList&&user.codeList.includes('WEBSITE.TOPICS.DETAILS.PLANNED_PAPERS')"
         @click="changeType('planned')"
         :class="['ipub-list-tab--status',type==='planned'?'active':'']">Planned Papers</a>
    </div>
    <div class="page-content">
      <ipub-table :columns="columns"
                  fixed
                  v-if="dataSource&&dataSource.length"
                  :pagination="pagination"
                  :dataSource="dataSource">
        <template v-slot:operator="{text}">
          <template v-if="text">{{text.firstName}} {{text.lastName}}</template>
          <template v-else>--</template>
        </template>
        <template v-slot:publish="{text}">
          <div class="ipub-table-status-show ipub-table-status-show--active"
               v-if="text === 'PUBLISHED'"></div>
          <div class="ipub-table-status-show"
               v-else-if="text === 'UNPUBLISHED'"></div>
          <div class="ipub-table-status-show ipub-table-status-show--disable"
               v-else-if="text === 'RETRACTION'"></div>
        </template>
        <!-- <template v-slot:time="{record}">
          {{ (record.updateTime||record.createTime)?$moment(record.updateTime||record.createTime).format('HH : mm DD / MM / YYYY'): '- -' }}
        </template> -->
        <template v-slot:actions="{ record }">
          <template v-if="type==='published'">
            <ipub-tooltip placement="bottomLeft"
                          action="click"
                          class="border-right">
              <div slot="title"
                   class="hover-action-content">
                <div class="ipub-cursor-pointer">
                  <a @click="openWebsite(record)"
                     v-if="record.xmlFile">
                    <ipub-icon type="iconhtml" />
                    Preview HTML
                  </a>
                  <font class="disabled-icon"
                        v-else>
                    <ipub-icon type="iconhtml" />
                    Preview HTML
                  </font>
                </div>
                <div class="ipub-cursor-pointer">
                  <a v-if="record.xmlFile"
                     target="_blank"
                     :href="`${domain}/${record.xmlFile.path}`">
                    <ipub-icon type="iconXML" />
                    Preview XML
                  </a>
                  <font class="disabled-icon"
                        v-else>
                    <ipub-icon type="iconXML" />
                    Preview XML
                  </font>
                </div>
                <div class="ipub-cursor-pointer">
                  <a v-if="record.pdfFile"
                     target="_blank"
                     :href="`${domain}/${record.pdfFile.path}`">
                    <ipub-icon type="iconPDF1" />
                    Preview PDF
                  </a>
                  <font class="disabled-icon"
                        v-else>
                    <ipub-icon type="iconPDF1" />
                    Preview PDF
                  </font>
                </div>
              </div>
              <ipub-icon type="iconViewDetails" />
            </ipub-tooltip>
            <template>
              <ipub-tooltip v-show="user.codeList&&user.codeList.includes('WEBSITE.PUBLISHING.EDIT')"
                            v-if="!((record.status === 'RETRACTION' || (record.status === 'PUBLISHED' && record.atype && record.atype.type !== 'RETRACTION' && record.retractionCode) && record.atype && record.atype.type !== 'RETRACTION'))"
                            class="border-right">
                <div slot="title">Edit</div>
                <ipub-icon type="iconEdit"
                           @click="editArticle(record)" />
              </ipub-tooltip>
              <ipub-icon v-else
                         class="disabled-icon"
                         type="iconEdit" />
            </template>
            <ipub-tooltip placement="bottomRight"
                          type="light"
                          action="click">
              <div style="font-size:14px"
                   class="hover-action-content"
                   slot="title">
                <template>
                  <div v-if="user.codeList&&user.codeList.includes('WEBSITE.PUBLISHING.PUBLISH')"
                       class="ipub-c-p">
                    <div v-if="record.status === 'UNPUBLISHED'"
                         @click="able(record, 'PUBLISHED')">
                      <ipub-icon type="iconAble" />Publish
                    </div>
                    <div v-else-if="record.status === 'PUBLISHED' && !(record.atype && record.atype.type !== 'RETRACTION' && record.retractionCode)"
                         @click="able(record, 'UNPUBLISHED')">
                      <ipub-icon type="iconDisable" />Unpublish
                    </div>
                    <template v-else>
                      <font class="disabled-icon">
                        <ipub-icon type="iconDisable" />Unpublish
                      </font>
                    </template>
                  </div>
                  <div v-if="user.codeList&&user.codeList.includes('WEBSITE.PUBLISHING.WITHDRAW')"
                       class="ipub-c-p">
                    <div v-if="record.status === 'RETRACTION'"
                         @click="able(record, 'PUBLISHED')">
                      <ipub-icon type="iconundo" />Cancel retraction
                    </div>
                    <div v-else-if="record.status === 'PUBLISHED' && record.atype && record.atype.type!=='RETRACTION'"
                         @click="able(record, 'RETRACTION')">
                      <ipub-icon type="icona-BacktoAuthor" />Retractions
                    </div>
                    <template v-else>
                      <font class="disabled-icon">
                        <ipub-icon type="icona-BacktoAuthor" />Retractions
                      </font>
                    </template>
                  </div>
                </template>
              </div>
              <ipub-icon type="iconMore" />
            </ipub-tooltip>
          </template>
          <template v-else-if="type==='planned'">
            <ipub-tooltip v-show="user.codeList&&(user.codeList.includes('WEBSITE.TOPICS.DETAILS.PLANNED_PAPERS.EDIT')||(!detail.released&&user.codeList.includes('WEBSITE.PUBLISHING.EDIT')))"
                          class="border-right">
              <div slot="title">Edit</div>
              <ipub-icon type="iconEdit"
                         @click="edit(record)" />
            </ipub-tooltip>
            <ipub-tooltip v-show="user.codeList&&user.codeList.includes('WEBSITE.TOPICS.DETAILS.PLANNED_PAPERS.DELETE')">
              <div slot="title">Delete</div>
              <ipub-icon type="iconDelete"
                         @click="del(record)" />
            </ipub-tooltip>
          </template>
        </template>
      </ipub-table>
      <template v-else>
        <ipub-empty v-if="type==='planned'">
          <div class="default-color ipub-h1 tc">No Planned Papers</div>
          <div style="margin-top:-4px"
               class="mar-b-40 default-color ipub-p1 tc">
            There is no reference yet. <a @click="add"
               class="link-color">Click here</a> to add new one
          </div>
        </ipub-empty>
        <ipub-empty v-else />
      </template>
    </div>
    <Add ref="planned-paper-add"
         :isVisable="isVisable"
         :id="id"
         @confirm="confirm"
         @cancel="cancel" />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
